

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const chartTableHeader = atom({key:'chartTableHeader', default:[]});
const chartTableData = atom({key:'chartTableData', default:[]});
const chartTableFilter = atom({key:'chartTableFilter', default:[]});
const entryMasterData = atom({key:'entryMasterData', default:{}});
const chartOfAccountEdit = atom({key:'chartOfAccountEdit', default:{}});
const chartOfAccountData = atom({key:'chartOfAccData', 
    default:{chart_of_accounts:[],display_column:[], filtering_criteria:[]}});
// Chart of Accounts
// : 
// (40) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
// Display Column
// : 
// (6) [{…}, {…}, {…}, {…}, {…}, {…}]
// Filtering Criteria



export  const SetChartEdit = () => useSetRecoilState(chartOfAccountEdit);
export  const GetChartEdit = () => useRecoilValue(chartOfAccountEdit);
export const ResetChartEdit = ()=> useResetRecoilState(chartOfAccountEdit);

export  const SetChartTableHead = () => useSetRecoilState(chartTableHeader);
export  const GetChartTableHead = () => useRecoilValue(chartTableHeader);




export  const SetChartEntryMasterData = () => useSetRecoilState(entryMasterData);
export  const GetChartEntryMasterData = () => useRecoilValue(entryMasterData);

export  const SetChartAccountData = () => useSetRecoilState(chartOfAccountData);
export  const GetChartAccountData = () => useRecoilValue(chartOfAccountData);



